import React from "react";
// import inigoMp3 from "../../assets/audio/inigo-greeting.mp3";
// import inigoOGG from "../../assets/audio/inigo-greeting.ogg";
// import inigoImg from "../../assets/img/pogi.JPG";

const block = {
    display: "block",
    width: "100%"
};

const mb10 = {
    marginBottom: "10px"
};

const Inigo = () => {
    return (
        <div className="island">
            <h2>Community Magazine</h2>

            <p>
                <a
                    href="https://issuu.com/worldvisionphl/docs/ebenezer"
                    title="Ebenezer"
                    target="_blank"
                >
                    Ebenezer
                </a>
            </p>
            <p>
                <a
                    href="https://issuu.com/worldvisionphl/docs/golden_valley"
                    title="Golden Valley"
                    target="_blank"
                >
                    Golden Valley
                </a>
            </p>

            {/* <img src={inigoImg} alt="wala pa rin" style={{...block, ...mb10}} />
      <p><b>Listen:</b> World Vision's newest ambassador, Inigo Pascual has a special New Year's message for you!</p>
      <hr />

      <audio controls controlsList="nodownload" style={block}>
        <source src={inigoOGG} type="audio/ogg"/>
        <source src={inigoMp3} type="audio/mpeg"/>
        Your browser does not support the audio tag.
      </audio> */}
        </div>
    );
};

export default Inigo;
